/**
 * Created by adalto on 6/3/14.
 */
App.Views.Task = {
    showLoadingElement: function (el) {

        var divDeleting = document.createElement('div');
        divDeleting.className = 'deleteLoading';

        el.appendChild(divDeleting);
    },

    hideLoad: function () {

        var divDeleting = document.querySelector('.deleteLoading');

        if (divDeleting) {
            divDeleting.remove();
        }
    },

    removeLoadingElement: function () {

        var deleteLoading = document.querySelector('.deleteLoading');
        var parent = ( deleteLoading !== null ) ? deleteLoading.parentNode : null;

        if (parent) {
            parent.removeChild(deleteLoading);
        }

    },
    renderMaps: function (selector, data) {

        const map = Greenmile.Map.Utility.createDefaultMap(selector);
        const baseLayer = Greenmile.Map.Utility.createBaseLayer();
        const optionsZoom = { zoomInTitle: '', zoomOutTitle: '' };
        baseLayer.addTo(map);

        new L.Control.Zoom(optionsZoom).addTo(map);

        const { stopMarker, locationMarker } = this.renderMarkers(map, data);

        return { 
            map,
            stopMarker,
            locationMarker
         };
    },

    appendTaskAdditionalInformation: function (task) {
        const formSection = document.querySelector('#Task .MonetUIFormSection[key="pls_edit_task_2"] #Task_organization');
        const taskInformation = document.createElement('div');
        taskInformation.className = 'taskInformation';

        const renderItem = (resource, value) => `
            <div class='taskInformationItem'>
                <div class='taskInformationLabel'>${Monet.I18n.getResourcesByKey(resource)}</div>
                <div class='taskInformationValue' id="${resource}">${value}</div>
            </div>
        `;

        taskInformation.innerHTML = `
            <div class='taskInformationColumn'>
                ${renderItem('task.header.createdAt', Monet.Format.DateTime.formatToLocale(task.created))}
                ${renderItem('task.header.userCreated', task.userCreated.name )}
            </div>
            <div class='taskInformationColumn'>
                ${renderItem('task.header.modifiedAt', Monet.Format.DateTime.formatToLocale(task.modified))}
                ${renderItem('task.header.status', Monet.I18n.getResourcesByKey(task.taskStatus.description))}
            </div>
        `;

        formSection.appendChild(taskInformation);
    },

    toogleForm: function (action) {

        const arrayActions = ['disable', 'enable'];
        const fieldsToNotToggle = ['organization'];
        const assignmentsFieldsToCheck = ['userAssigned', 'groupAssigned'];
        const checkAssignmentsFields = (field) => {
            let isFieldAlreadyDisabled = false;
            const value = field.getValue();

            if (assignmentsFieldsToCheck.includes(field.name) && !value) {
                isFieldAlreadyDisabled = field.input.disabled;
            }

            return isFieldAlreadyDisabled;
        };

        if (arrayActions.indexOf(action) !== -1) {

            const rootEl = App.Forms.Task.form.rootEl;
            const fieldList = App.Forms.Task.form.fields;
            const buttonsToDisable = ['btn_save', 'btn_link_to_task', 'add_comment'];
            const buttonList = rootEl.querySelectorAll('input[type="button"]');
            const trashIconList = rootEl.getElementsByClassName('table-action-destroylink');
            const editIconList = rootEl.getElementsByClassName('table-action-editlink');
            const toDisable = (action === 'enable') ? false : true;
            const displayModeToIcon = (action === 'enable') ? 'block' : 'none';

            for (let key in fieldList) {
                const field = fieldList[key];
                const isAssignmentFieldAlreadyDisabled = checkAssignmentsFields(field);

                if (
                    field[action] &&
                    field.input &&
                    !fieldsToNotToggle.includes(key) &&
                    !isAssignmentFieldAlreadyDisabled
                ) {
                    field[action]();
                }
            }

            for (let buttonItem = 0, buttomItemLength = buttonList.length; buttonItem < buttomItemLength; buttonItem++) {
                const button = buttonList[buttonItem];
                if (buttonsToDisable.indexOf(button.name) !== -1) {
                    button.disabled = toDisable;
                }
            }

            for (let trashItem = 0, trashItemLength = trashIconList.length; trashItem < trashItemLength; trashItem++) {
                trashIconList[trashItem].style.display = displayModeToIcon;
            }

            for (let editItem = 0, editItemLength = editIconList.length; editItem < editItemLength; editItem++) {
                editIconList[editItem].style.display = displayModeToIcon;
            }

            App.Objects.Task.editor.e.body.contentEditable = !toDisable;
        }
    },
    verifyTaskStatusAndToogleForm: function (flowArray) {
        var action = (flowArray[0].nextWorkflowStatus.taskStatus.key === 'reopenedStatus') ? 'disable' : 'enable';
        App.Views.Task.toogleForm(action);

    },

    assignToMe: function () {
        var loggedUser = Monet.Session.User;
        var userAssignedField = App.Forms.Task.form.fields.userAssigned;
        userAssignedField.setValue({ id: loggedUser.id, name: loggedUser.name });
    },

    renderMarkers: (map, data) => {
        const locationIcon = L.icon({
            iconUrl: data.locationIcon ? require("./../../static/" + data.locationIcon) : require('static/images/map/markers/location.png')
        });
        const markerIcon = L.icon({
            iconUrl: data.icon ? require("./../../static/" + data.icon) : require('static/images/map/markers/location.png')
        });
        let stopMarker = null;
        let locationMarker = null;

        if (data.stopLatitude && data.stopLongitude) {
            stopMarker = L.marker([data.stopLatitude, data.stopLongitude], { icon: locationIcon });
            stopMarker.addTo(map);
            if(data.popText) {
                const point = new L.Point(48, 20);
                stopMarker.bindPopup('<div style="padding: 10px">'+ data.popText +'</div>',{
                    offset: point,
                    minWidth: 70
                }).openPopup();
            }
        }
        
        if (data.latitude && data.longitude) {
            locationMarker = L.marker([data.latitude, data.longitude], { icon: markerIcon });
            locationMarker.addTo(map);
            map.panTo([data.latitude, data.longitude]);
        }

        if(data.latitude && data.longitude && data.stopLatitude && data.stopLongitude) {
            map.fitBounds([
                [data.latitude, data.longitude],
                [data.stopLatitude, data.stopLongitude]
            ]);
        }

        return { 
            stopMarker,
            locationMarker
        }
    },

    updateMarkers: function(data, map) {
        map.stopMarker && map.stopMarker.remove();
        map.locationMarker && map.locationMarker.remove();
        map.map && this.renderMarkers(map.map, data);
    }
};